import {
  Button,
  CircularProgress,
  Input,
  Modal,
  Option,
  Select,
  selectClasses,
  styled,
  SvgIcon,
  Textarea,
} from "@mui/joy";
import { BASE_URL, BLACK, PRIMARY, WHITE } from "../../../appConstants";
import React, {
  ChangeEvent,
  Dispatch,
  FormEvent,
  SetStateAction,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import MultiSelect from "../../commonComponents/MultiSelect";
import CrossIcon from "../../../svg/Ads_Dashboard_Developement2/CrossIcon/elements.svg";

type SearchDataArrProps = {
  value: string;
};
type All_CategoriesProps = {
  principal_category: SearchDataArrProps[];
  main_category: SearchDataArrProps[];
  category: SearchDataArrProps[];
  sub_category: SearchDataArrProps[];
  ad_type: SearchDataArrProps[];
  campaign_name: SearchDataArrProps[];
  adgroup_name: SearchDataArrProps[];
  targeting: SearchDataArrProps[];
  match_type: SearchDataArrProps[];
  sfr: SearchDataArrProps[];
  searchterm: SearchDataArrProps[];
};
type All_Sel_CategoriesProps = {
  principal_category: string[];
  main_category: string[];
  category: string[];
  sub_category: string[];
  ad_type: string[];
  campaign_name: string[];
  adgroup_name: string[];
  targeting: string[];
  match_type: string[];
  sfr: string[];
  searchterm: string[];
};
type AddKeywordTypeProps = {
  setFilterToggle: Dispatch<SetStateAction<boolean>>;
  setFilterState: Dispatch<SetStateAction<All_Sel_CategoriesProps>>;
  categories: All_CategoriesProps;
  sel_categories : All_Sel_CategoriesProps;
};
type list_Type = {
  id: string;
  label: string;
};

const FilterModal: React.FC<AddKeywordTypeProps> = ({
  setFilterToggle,
  setFilterState,
  categories,
  sel_categories
}) => {
  // // -- BCG TYPE
  // const [selectedBcgType, setSelectedBcgType] = useState<Set<string>>(
  //   new Set([])
  // );

  // const [bcgTypeList, setBcgTypeList] = useState<list_Type[]>([]);

  // const onBcgTypeChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
  //   let set = new Set(selectedBcgType);
  //   if (e.target.checked) {
  //       if (id === "Select All") {
  //           bcgTypeList.forEach((m) => set.add(m?.id));
  //       }
  //       else if(id !== "Select All"){
  //           set.add(id);
  //           if(set.size === bcgTypeList.length - 1){
  //               set.add('Select All');
  //           }
  //       }
  //   } else {
  //       if (id === "Select All" && set.size === bcgTypeList.length) {
  //           set.clear();
  //       }
  //       else if( id !== "Select All"){
  //           if (set.has("Select All")) {
  //               set.delete("Select All");
  //             }
  //           set.delete(id);
  //       }
  //   }
  //   setSelectedBcgType(set);
  // };

  // // --- Targeting Type
  // const [selectedTargetingType, setSelectedTargetingType] = useState<Set<string>>(
  //   new Set([])
  // );

  // const [targetingTypeList, setTargetingTypeList] = useState<list_Type[]>([]);

  // const onTargetingTypeChange = (
  //   e: React.ChangeEvent<HTMLInputElement>,
  //   id: string
  // ) => {
  //   let set = new Set(selectedTargetingType);
  //   if (e.target.checked) {
  //     if (id === "Select All") {
  //       targetingTypeList.forEach((m) => set.add(m?.id));
  //     } else if (id !== "Select All") {
  //       set.add(id);
  //       if (set.size === targetingTypeList.length - 1) {
  //         set.add("Select All");
  //       }
  //     }
  //   } else {
  //     if (id === "Select All" && set.size === targetingTypeList.length) {
  //       set.clear();
  //     } else if (id !== "Select All") {
  //       if (set.has("Select All")) {
  //         set.delete("Select All");
  //       }
  //       set.delete(id);
  //     }
  //   }
  //   setSelectedTargetingType(set);
  // };

  // --- Match Type
  const [selectedMatchType, setSelectedMatchType] = useState<Set<string>>(
    new Set([])
  );

  const [matchTypeList, setMatchTypeList] = useState<list_Type[]>([]);

  const onMatchTypeChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    let set = new Set(selectedMatchType);
    if (e.target.checked) {
      if (id === "Select All") {
        matchTypeList.forEach((m) => set.add(m?.id));
      } else if (id !== "Select All") {
        set.add(id);
        if (set.size === matchTypeList.length - 1) {
          set.add("Select All");
        }
      }
    } else {
      if (id === "Select All" && set.size === matchTypeList.length) {
        set.clear();
      } else if (id !== "Select All") {
        if (set.has("Select All")) {
          set.delete("Select All");
        }
        set.delete(id);
      }
    }
    setSelectedMatchType(set);
  };

  // --- Ad Type
  const [selectedAdType, setSelectedAdType] = useState<Set<string>>(
    new Set([])
  );

  const [adTypeList, setAdTypeList] = useState<list_Type[]>([]);

  const onAdTypeChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    let set = new Set(selectedAdType);
    if (e.target.checked) {
      if (id === "Select All") {
        adTypeList.forEach((m) => set.add(m?.id));
      } else if (id !== "Select All") {
        set.add(id);
        if (set.size === adTypeList.length - 1) {
          set.add("Select All");
        }
      }
    } else {
      if (id === "Select All" && set.size === adTypeList.length) {
        set.clear();
      } else if (id !== "Select All") {
        if (set.has("Select All")) {
          set.delete("Select All");
        }
        set.delete(id);
      }
    }
    setSelectedAdType(set);
  };

  const clearFilterHandler = () => {
    setSelectedMatchType(new Set([]));
    setSelectedAdType(new Set([]));
  }

  const SaveFilterStateHandler = () => {
    setFilterState((prev) => ({
      ...prev,
      match_type:
        selectedMatchType.size > 0
          ? selectedMatchType.has("Select All")
            ? matchTypeList
                .filter((item) => item?.label !== "Select All")
                .map((item) => item?.label)
            : matchTypeList
                .filter((item) => selectedMatchType.has(item?.id))
                .map((item) => item.label)
          : [],
      ad_type:
        selectedAdType.size > 0
          ? selectedAdType.has("Select All")
            ? adTypeList.filter((item) => item?.label !== "Select All").map(
                (item) => item?.label
              )
            : adTypeList.filter((item) => selectedAdType.has(item?.id)).map(
                (item) => item?.label
              )
          : [],
    }));
    setFilterToggle(false);
  };

  useEffect(() => {
    if (categories?.match_type) {
      setMatchTypeList(() => {
        let objList = categories.match_type.map((obj) => ({
          id: obj?.value,
          label: obj?.value,
        }));
        return [{id:'Select All', label: 'Select All'}, ...objList];
      });
    } 

    if (categories?.ad_type) {
      setAdTypeList(() => {
        let objList = categories.ad_type.map((obj) => ({
          id: obj?.value,
          label: obj?.value,
        }));
        return [{id:'Select All', label: 'Select All'}, ...objList];
      });
    } 
  }, [categories]);

  const isFilterEmpty = () => {
    return (
      (selectedAdType?.size ?? 0) > 0 || 
      (selectedMatchType?.size ?? 0) > 0 
    );
  };  

  useEffect(() => {
    if(sel_categories?.ad_type?.length > 0){
      setSelectedAdType(() => {
        const bcgSet = new Set<string>();
      
        sel_categories?.ad_type?.forEach((obj_name) => bcgSet.add(obj_name));
      
        return new Set(bcgSet); // Return a new Set to ensure state updates
      });
    }
    if(sel_categories?.match_type?.length > 0){
      setSelectedMatchType(() => {
        const bcgSet = new Set<string>();
      
        sel_categories?.match_type?.forEach((obj_name) => bcgSet.add(obj_name));
      
        return new Set(bcgSet); // Return a new Set to ensure state updates
      });
    }
  }, [sel_categories]);

  return (
    <Modal
      open={true}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      className="h-full"
    >
      <div className="relative">
      <div
        style={{
          width: 680,
          height: 346,
          paddingLeft: 40,
          paddingRight: 40,
          paddingBottom: 40,
          paddingTop: 52,
          backgroundColor: `${WHITE.W_100}`,
        }}
        className="flex flex-col items-center justify-between rounded-[16px] gap-10"
      >
        <div className="flex flex-col w-full">
          <div
            className="self-stretch"
            style={{
              color: `#1C1C1E`,
              fontSize: 20,
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "26px",
            }}
          >
            Add New Filters
          </div>
          <div
            className="self-stetch"
            style={{
              color: `#97979A`,
              fontSize: 14,
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "22px",
            }}
          >
            Define new filter conditions to refine your data view
          </div>
        </div>

        <div className="flex flex-col w-full gap-4">
          {/* <div className="flex gap-4 items-start self-stretch">
            <div className="w-[50%] flex flex-col gap-[4px]">
              <div
                className="flex flex-col justify-center self-stretch"
                style={{
                  fontSize: 14,
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "18px",
                  color: "#1C1C1E",
                }}
              >
                BCG Type
              </div>
              <MultiSelect
                children={bcgTypeList}
                selected={selectedBcgType}
                onChange={onBcgTypeChange}
                placeholder="Select BCG Type"
                checkboxcolor="primary"
              />
            </div>

            <div className="w-[50%] flex flex-col gap-[4px]">
              <div
                className="flex flex-col justify-center self-stretch"
                style={{
                  fontSize: 14,
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "18px",
                  color: "#1C1C1E",
                }}
              >
                Targeting Type
              </div>
              <MultiSelect
                children={targetingTypeList}
                selected={selectedTargetingType}
                onChange={onTargetingTypeChange}
                placeholder="Select Targeting Type"
                checkboxcolor="primary"
              />
            </div>
          </div> */}

          <div className="flex gap-4 items-start self-stretch">
            <div className="w-[50%] flex flex-col gap-[4px]">
              <div
                className="flex flex-col justify-center self-stretch"
                style={{
                  fontSize: 14,
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "18px",
                  color: "#1C1C1E",
                }}
              >
                Match Type
              </div>
              <MultiSelect
                children={matchTypeList}
                selected={selectedMatchType}
                onChange={onMatchTypeChange}
                placeholder="Select Match Type"
                checkboxcolor="primary"
              />
            </div>

            <div className="w-[50%] flex flex-col gap-[4px]">
              <div
                className="flex flex-col justify-center self-stretch"
                style={{
                  fontSize: 14,
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "18px",
                  color: "#1C1C1E",
                }}
              >
                Ad Type
              </div>
              <MultiSelect
                children={adTypeList}
                selected={selectedAdType}
                onChange={onAdTypeChange}
                placeholder="Select Ad Type"
                checkboxcolor="primary"
              />
            </div>
          </div>
        </div>

        <div className="flex items-start justify-center gap-4 self-stretch">
          <Button
            color="neutral"
            sx={{
              height: "40px",
              width: "50%",
              backgroundColor: "#FFF",
              ":hover": {
                backgroundColor: "#FFF",
              },
              color: isFilterEmpty() ? "#1C1C1E" : "#B7B7B9",
              borderRadius: "8px",
              border: "1px solid #F2F2F5",
              padding: "0px 8px",
              fontSize: "14px",
              fontWeight: 700,
              lineHeight: "18px",
            }}
            onClick={clearFilterHandler}
          >
            Clear Filter
          </Button>
          <Button
            onClick={SaveFilterStateHandler}
            sx={{
              height: "40px",
              width: "50%",
              backgroundColor: "#1565C0",
              color: "#FFF",
              borderRadius: "8px",
              padding: "0px 8px",
              fontSize: "14px",
              fontWeight: 700,
              lineHeight: "18px",
            }}
          >
            Save
          </Button>
        </div>
      </div>

      <div
          className="absolute top-4 right-4 flex p-1 "
          style={{
            zIndex: 100,
            backgroundColor: "#F2F2F5",
            borderRadius: "20px"
          }}
        >
          <img
            src={CrossIcon}
            alt="OverView Icon"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setFilterToggle(false);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default FilterModal;
